import SpeedTest from '@cloudflare/speedtest';
import { useEffect, useState } from 'react';

interface Scores {
  [key: string]: {
    points: number;
    classificationIdx: 0 | 1 | 2 | 3 | 4;
    classificationName: 'bad' | 'poor' | 'average' | 'good' | 'great';
  };
}

interface Summary {
  download?: number;
  upload?: number;
  latency?: number;
  jitter?: number;
  downLoadedLatency?: number;
  downLoadedJitter?: number;
  upLoadedLatency?: number;
  upLoadedJitter?: number;
  packetLoss?: number;
}

export const useSpeedtest = () => {
  const [summary, setSummary] = useState<Summary | null>(null);
  const [scores, setScores] = useState<Scores | null>(null);
  const [finished, setFinished] = useState<boolean>(false);

  useEffect(() => {
    const speedtest = new SpeedTest({});
    setFinished(false);

    speedtest.onResultsChange = () => {
      setSummary(speedtest.results.getSummary());
      setScores(speedtest.results.getScores());
    };

    speedtest.onFinish = (results) => {
      setFinished(true);
      setScores(results.getScores());
      setSummary(results.getSummary());
    };

    return () => {
      speedtest.pause();
    };
  }, [setScores, setSummary, setFinished]);

  return { scores, summary, finished };
};
